import React from 'react'
import { Typography, Grid } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { primaryFormat as primaryFormatSelector } from '../../../account/selectors'
import PlanogramLink from './PlanogramLink'
import { StyledSpan } from '../../../theme/Global'

const Planograms = ({ country, planograms}) => {
  const countryCode = country === 'CA' ? 'CA' : 'US'
  const countryText = countryCode === 'CA' ? 'Canada' : 'United States'
  const planogramFormat = useSelector(primaryFormatSelector)


  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography align="right">
          <StyledSpan> {countryText} Poster Planograms</StyledSpan>
          <br />
          <PlanogramLink
            planograms={planograms}
            planogramFormat={planogramFormat}
            countryCode={countryCode}
          />
        </Typography>
      </Grid>
    </Grid>
  )
}

export default Planograms
